module.exports = __webpack_public_path__ + "c517aac4.png";